<template>
  <div class="footer">
    
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
     
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  text-align: center;
  padding: 40px 0;
  width: 100%;
  margin-top: auto;
}
</style>
